/* unplugin-vue-components disabled */
import {FilterContext} from 'mixins'

export default {
  mixins: [ModelValue(Array)],
  provide(){
    return {
      [FilterContext.context]: {
        next: {
          get: () => this.next,
          set: v => this.next = v
        },
        prev: {
          get: () => this.prev,
          set: v => this.prev = v
        }
      }
    }
  },
  props: {
    title: {type: String, required: true}, 
  },
  emits: ['apply', 'on-apply'],
  data() {
    return {
      prev: [],
      next: [],
    }
  },
  computed: {
    can_apply() {
      return !$utils.compare.same(this.prev, this.next)
    }
  },
  watch: {
    value() {
      if (this.next !== this.value) this.next = this.value
      this.prev = this.value
    }
  },
  mounted() {
    if (this.value) {
      this.prev = this.value
      this.next = this.value
    }
  },
  methods: {
    onReset(){
      this.prev = []
      this.next = []
      this.onApply()
    },
    async onApply() {
      this.$emit('on-apply')
      this.value = this.next
    },
  }
}
